export const customerAppointmentStatuses = {
  SCHEDULED: 'Solicitado · aguardando confirmação',
  CONFIRMED: 'Confirmado',
  CANCELLED: 'Cancelado',
  COMPLETED: 'Realizado',
  NO_SHOW: 'Não compareceu',
};
